/** Strip non-digits; leading 0 (local Ghana-style) → 233… for API. */
export function normalizePhoneForApi(raw) {
  const d = String(raw || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("0") && d.length >= 10) return `233${d.slice(1)}`;
  return d;
}
